import { createStore } from 'vuex'
import Vuex from 'vuex'

// Vuex modules have been migrated to Pinia. Keep an empty store so existing
// `app.use(store)` / `window.$_store` bootstraps do not break.
let store = new Vuex.Store({
    plugins: [],
    modules: {},
})

window.$_store = store

export default store
